import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';
import { Premix, PreviewPremix } from '../../entities/premixes/premixes.types';
import {
  AddIngredientPayload,
  EntryMethodsKeys,
  MixerDataInIngredient,
  TargetWeights,
} from '../recipes/appRecipes.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/appPremix');

export const setEditModeInPremixCreation = actionCreator<boolean>('SET_EDIT_MODE_IN_PREMIX_CREATION');
export const setAutoAdjWater = actionCreator<boolean>('SET_AUTO_ADJ_WATER');
export const setMethod = actionCreator<EntryMethodsKeys>('SET_METHOD');
export const setTargetWeightType = actionCreator<TargetWeights>('SET_TARGET_WEIGHT_TYPE');
export const setWaterAmount = actionCreator<number>('SET_WATER_AMOUNT');
export const addIngredientInPremix = actionCreator<AddIngredientPayload>('ADD_INGREDIENT_IN_PREMIX');
export const addIngredientInPremixSilent = actionCreator<AddIngredientPayload>('ADD_INGREDIENT_IN_PREMIX_SILENT');
export const deleteIngredientInPremix = actionCreator<{ id: string }>('DELETE_INGREDIENT_IN_PREMIX');
export const setSelectedIngredientInList = actionCreator<string | null>('SET_SELECTED_INGREDIENT_IN_LIST');
export const emptyIngredientsInPremix = actionCreator('EMPTY_INGREDIENT_IN_PREMIX');
export const updateIngredientOrderInPremix = actionCreator<any>('UPDATE_INGREDIENT_ORDER_IN_PREMIX');

export const setEditPremix = actionCreator<Premix>('SET_EDIT_PREMIX');

export const updateMixerData = actionCreator<{ listId: string; mixerData: MixerDataInIngredient }>('UPDATE_MIXER_DATA');
export const updateActualLoad = actionCreator<{ listId: string; actualLoad: number }>('UPDATE_ACTUAL_LOAD');
export const updateDryMatter = actionCreator<{ listId: string; dryMatter: number }>('UPDATE_DRY_MATTER');
export const updateActualLoadPercentage = actionCreator<{ listId: string; actualLoadPercentage: number }>(
  'UPDATE_ACTUAL_LOAD_PERCENTAGE',
);
export const updateDryMatterPercentage = actionCreator<{ listId: string; dryMatterPercentage: number }>(
  'UPDATE_DRY_MATTER_PERCENTAGE',
);
export const setActualLoadTargetWeight = actionCreator<number>('SET_ACTUAL_LOAD_TARGET_WEIGHT');
export const setDryMatterTargetWeight = actionCreator<number>('SET_DRY_MATTER_TARGET_WEIGHT');

export const sendPremixPayload = actionCreator<{}>('SEND_PREMIX_PAYLOAD');
export const previewCreatePremix = actionCreator.async<{}, PreviewPremix, any>('PREVIEW_CREATE_PREMIX');
